import { type UseQueryOptions } from 'react-query'

import { apiPaths } from 'api/kinerja/kepala-sekolah/config'
import { useKinerjaApi } from 'api/kinerja/utils/api'

import type { KinerjaRoleType } from 'types/kinerja'
import type {
  PelaksanaanDinas,
  PelaksanaanDinasMeta,
} from 'types/kinerja-ks-pelaksanaan'
import type { CommonListResponse } from 'types/api'

export const API_GET_KS_PELAKSANAAN_BY_DINAS_QUERY_KEY =
  'API_GET_KS_PELAKSANAAN_BY_DINAS_QUERY_KEY'

type ParamsGetPelaksanaan = {
  role: KinerjaRoleType
  page?: number
  pageSize?: number
}

export function getPelaksanaanDinasQuerykeys(params: ParamsGetPelaksanaan) {
  return [
    API_GET_KS_PELAKSANAAN_BY_DINAS_QUERY_KEY,
    params?.page || 1,
    params?.pageSize || 10,
    params?.role || '',
  ]
}

export function useApiGetPelaksanaanDinas(
  params: ParamsGetPelaksanaan,
  opts?: UseQueryOptions<
    CommonListResponse<PelaksanaanDinas, PelaksanaanDinasMeta>
  >
) {
  const page = params?.page || 1
  const pageSize = params?.pageSize || 10
  const role = params?.role || undefined

  return useKinerjaApi<
    CommonListResponse<PelaksanaanDinas, PelaksanaanDinasMeta>
  >(apiPaths.pelaksanaanDinas, {
    axiosConfig: {
      params: {
        page,
        pageSize,
        role,
      },
    },
    queryConfig: {
      enabled: false,
      retry: false,
      useErrorBoundary: false,
      keepPreviousData: true,
      ...opts,
    },
    queryKey: getPelaksanaanDinasQuerykeys(params),
  })
}
